import React, { useState } from 'react'
import { useSelector } from 'react-redux';
const ChatGoogleBusinessai = ({ isWhiteLable }) => {
    const [showBusinessChat, setshowBusinessChat] = useState('first');
    const hideAndShowChat = (type) => {
        setshowBusinessChat(type);
    }
    const state = useSelector((state) => state);

    return (
        <>

            <div><h3 className="mb-4 fs-5 fw-bold left-side_heading" style={{ textTransform: "none" }} >How we look on Google Business Profile</h3>
                {showBusinessChat === 'first' &&
                    <>
                        {/* <img src={`${process.env.PUBLIC_URL}/images/${isWhiteLable ? 'white-arrow-grey.svg' : 'close-arrow.svg'}`} alt="arrow_img" className="img-fluid arrow_img2" /> */}
                        <img src={`${process.env.PUBLIC_URL}/images/${isWhiteLable ? 'white-arrow-grey1.svg' : 'close-arrow.svg'}`} alt="arrow_img" className="img-fluid arrow_img" />
                        <img src={`${process.env.PUBLIC_URL}/images/${isWhiteLable ? 'arrow_mobile-grey.svg' : 'arrow_mobile.svg'}`} alt="arrow_img" className="img-fluid mobile_arrow grey-arrow-mb" />
                        {isWhiteLable ?
                            <div className='caption3'
                                style={isWhiteLable && { backgroundImage: 'linear-gradient(45deg,' + state.app.contextData?.primaryColor + ',' + state.app.contextData?.secondaryColor + ')', color: state.app.contextData?.buttonTextColor }}


                            >
                                Click here to start. This is how a customer will start
                                a Google Business Profile chat with your company
                            </div> :
                            <div className='caption2'>
                                Click here to start. This is how a customer will start
                                a Google Business Profile chat with your company
                            </div>}
                        {/* <div class="caption2">Click on the next on the "x" icon to go back</div> */}

                        {/* <div id="position-relative mobile_One"> */}
                        <div id="img_place">

                            {/* <div className="opaque" id="img1">
                                <img src={`${process.env.PUBLIC_URL}/images/mobile_img.svg`} alt="busines profile" className="img-fluid" />
                                <div className='chatclickbox' onClick={() => hideAndShowChat('second')}></div>
                            </div> */}
                            <div className="opaque" id="img1">
                                <img src={`${process.env.PUBLIC_URL}/images/${isWhiteLable ? 'mobile-1.svg' : 'mobile-1.svg'}`} alt="busines profile" className="img-fluid" />
                                <div className='chatclickbox' onClick={() => hideAndShowChat('second')}></div>
                            </div>
                        </div>
                    </>
                }
                {showBusinessChat === 'second' &&
                    <>
                        <img src={`${process.env.PUBLIC_URL}/images/${isWhiteLable ? 'white-arrow.svg' : 'close-arrows-2.svg'}`} alt="arrow_img" className={`img-fluid arrow_img2 arrow_img3  ${isWhiteLable && `grey_arrow-top`}`} />
                        {/* <div class="col-lg-4 back_btn position-relative"> */}
                        <img src={`${process.env.PUBLIC_URL}/images/${isWhiteLable ? 'white-arrow-grey.svg' : 'arrow_mobile.svg'}`} alt="arrow_img" className={`img-fluid mobile_arrow ${isWhiteLable && `bottom-grey-arrow`}`} />
                        {isWhiteLable ?
                            <div className='caption3'
                                style={isWhiteLable && { backgroundImage: 'linear-gradient(45deg,' + state.app.contextData?.primaryColor + ',' + state.app.contextData?.secondaryColor + ')', color: state.app.contextData?.buttonTextColor }}

                            >
                                Click on the next on the X icon to go back

                            </div> :

                            <div className='caption2'>

                                Click on the next on the X icon to go back
                            </div>}
                        <div id="img_place">
                            <div className="opaque" id="img1">
                                <img src={`${process.env.PUBLIC_URL}/images/${isWhiteLable ? 'white-mobile.svg' : 'mobile_img.svg'}`} alt="busines profile" className="img-fluid" />
                                <div className='chatclickbox2' onClick={() => hideAndShowChat('first')}></div>
                            </div>
                        </div>
                    </>
                }
            </div>
        </>
    )
}

export default ChatGoogleBusinessai